import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { LoadingContainerComponent } from './components';
import { LoaderService } from './loader.service';

const components = [LoadingContainerComponent];

@NgModule({
	imports: [CommonModule, RouterModule],
	declarations: [...components],
	providers: [LoaderService],
	exports: [...components],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoadingModule {}
